import { gql } from "graphql-tag";
import { responseField } from "../../../base.graphql";

export const geographicalZoneFields = `
id
uniqueId
name
description
createdDate
isActive
regions {
    id
    regionUniqueId
    regionName
    regionPostcode
    regionNapaId
}
`;

export const paginationFields = `
number
hasNextPage
hasPreviousPage
currentPageNumber
nextPageNumber
previousPageNumber
numberOfPages
totalElements
pagesNumberArray
`;

export const GET_ALL_GEOGRAPHICAL_ZONES_QUERY = gql`
    query GetAllGeographicalZones($filtering:GeographicalZonesFilteringInputObject) {
        getAllGeographicalZones (filtering:$filtering){
            response {
                ${responseField}
            }
            data {
                ${geographicalZoneFields}
            }
            page {
                ${paginationFields}
            }
        }
    }
`;

export const CREATE_GEOGRAPHICAL_ZONE_MUTATION = gql`
    mutation RegisterGeographicalZonesMutation($input: GeographicalZonesInputObject!) {
        registerGeographicalZonesMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${geographicalZoneFields}
            }
        }
    }
`;

export const UPDATE_GEOGRAPHICAL_ZONE_MUTATION = gql`
    mutation UpdateGeographicalZonesMutation($input: GeographicalZonesInputObject!) {
        updateGeographicalZonesMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${geographicalZoneFields}
            }
        }
    }
`;

export const DELETE_GEOGRAPHICAL_ZONE_MUTATION = gql`
    mutation DeleteGeographicalZonesMutation($uniqueId: String!) {
        deleteGeographicalZonesMutation(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
        }
    }
`;

export const GET_GEOGRAPHICAL_ZONE_BY_ID_QUERY = gql`
    query GetGeographicalZoneById($uniqueId: String!) {
        getGeographicalZoneById(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
            data {
                ${geographicalZoneFields}
            }
        }
    }
`;
